import { useCallback } from 'react';
import { Card, Form } from 'react-bootstrap';

import { useFormikContext } from 'formik';

import { updateQueryStringOnFieldChange } from '@components/Filters/Filters';
import { useThrottle } from '@features/useThrottle';

export const InvoicesFilter = ({ searchParams, setSearchParams }) => {
  const { handleChange, handleBlur, values } = useFormikContext();
  const throttle = useThrottle((event) => {
    updateQueryStringOnFieldChange(event, { searchParams, setSearchParams });
  }, 500);
  const throttledChangeHandler = useCallback(
    (event) => {
      handleChange(event);
      throttle(event);
    },
    [throttle]
  );
  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Search form</Card.Header>
      <Card.Body>
        <Form.Group className="mb-3" controlId="formGroupInvoiceID">
          <Form.Label>InvoiceID</Form.Label>
          <Form.Control
            type="input"
            name="invoiceID"
            size="sm"
            value={values.invoiceID}
            onChange={throttledChangeHandler}
            onBlur={handleBlur}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupInvoiceStartDate">
          <Form.Label>Date invoice from</Form.Label>
          <Form.Control
            name="invoiceStartDate"
            type="date"
            size="sm"
            value={values.invoiceStartDate}
            onChange={throttledChangeHandler}
            onBlur={handleBlur}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupInvoiceEndDate">
          <Form.Label>Date invoice to</Form.Label>
          <Form.Control
            name="invoiceEndDate"
            type="date"
            size="sm"
            value={values.invoiceEndDate}
            onChange={throttledChangeHandler}
            onBlur={handleBlur}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupInvoiceDueStartDate">
          <Form.Label>Date due from</Form.Label>
          <Form.Control
            name="invoiceDueStartDate"
            type="date"
            size="sm"
            value={values.invoiceDueStartDate}
            onChange={throttledChangeHandler}
            onBlur={handleBlur}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formGroupInvoiceDueEndDate">
          <Form.Label>Date due to</Form.Label>
          <Form.Control
            name="invoiceDueEndDate"
            type="date"
            size="sm"
            value={values.invoiceDueEndDate}
            onChange={throttledChangeHandler}
            onBlur={handleBlur}
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};
